import { Box } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const CardHolderText = styled(Box)`
  font-family: Arial;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.BLACK_900};
`
